import { useEffect, useState } from "react";

import useAuth from "@/providers/hooks/useAuthProvider";

import { UserData, addUserDataListener, getUserDataCache } from "./useUserPermissionsSync";

/**
 * Custom hook to use both cached user data and JWT token data
 * This hook combines both data sources and returns the most up-to-date information
 *
 * @returns Object containing effective user data and related states
 */
const useCachedUserData = () => {
    const { userData: authUserData } = useAuth();
    const [cachedUserData, setCachedUserData] = useState<UserData | null>(getUserDataCache());

    // Use both JWT token and cache data - prefer cache data if available
    const effectiveUserData = cachedUserData || authUserData;
    // console.log("effectiveUserData", effectiveUserData);
    // console.log("authUserData", authUserData);
    // console.log("cachedUserData", cachedUserData);

    // Listen for cache changes
    useEffect(() => {
        // On first render, get data from cache
        setCachedUserData(getUserDataCache());

        // Add a listener for cache changes
        const unsubscribe = addUserDataListener(() => {
            const newData = getUserDataCache();
            setCachedUserData(newData);
        });

        return unsubscribe;
    }, []);

    return {
        effectiveUserData,
        cachedUserData,
        authUserData,
        isDataLoaded: !!effectiveUserData,
    };
};

export default useCachedUserData;
